'use strict';
/**
 * @file calendar.js
 * @author dxh
 */



    require('../coord/calendar/Calendar');
    require('../coord/calendar/CalendarModel');
    require('./calendar/CalendarView');





//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/calendar.js
// module id = 434
// module chunks = 1